import TopCompaniesTitle from './TopCompaniesTitle';

export default TopCompaniesTitle;
